import ProductService from '../service/ProductService'

class ProductFactory {
  /**
   * 处理点赞
   */
  static doFollow (product = {}) {
    const status = product.is_follow ? 0 : 1
    const product_id = product.id
    // 先设置状态再提交
    product.is_follow = status
    // 提交关注
    ProductService.doFollow({ product_id, status })
    return product
  }

  /**
   * 添加评论
   */
  static doComment ({ product, commentObj, commentForm }) {
    const product_id = product.id
    const content = commentForm.content
    const pid = commentForm.pid
    return ProductService.doComment({ product_id, content, pid }).then(res => {
      if (res.data.data) {
        commentObj.count += 1
        const comment = res.data.data
        if (comment.pid !== 0) {
          commentObj.list.map(item => {
            if (item.id === comment.pid) {
              item.reply.list.unshift(comment)
            }
          })
        } else {
          comment.reply = {
            list: []
          }
          commentObj.list.unshift(comment)
        }
        return Promise.resolve(commentObj)
      }
      return Promise.reject(new Error('Comment Faild'))
    })
  }
}

export default ProductFactory
